import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class GetPassengerWithCheckingAccountByCarrierCommand extends IRequestCommand<
  IGetPassengerWithCheckingAccountByCarrierResponse,
  ErrorDetails,
  IGetPassengerWithCheckingAccountByCarrierParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'passengers/{carrierId}/withCheckingAccountByCarrier';

  public override setParameters(parameters: IGetPassengerWithCheckingAccountByCarrierParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId.toString() : ''
    );
  }
}

export interface IGetPassengerWithCheckingAccountByCarrierParameters {
  carrierId?: string;
}

export interface IGetPassengerWithCheckingAccountByCarrierResponse extends ICommandResponse {
}
